<template>
    <b-modal v-bind="$attrs" v-on="$listeners" :id="id" :ok-title="okTitle" :cancel-title="cancelTitle" :title="title" scrollable @ok="onOk">
        <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope">
            <div :class="!!tall ? 'tall' : ''" :key="slot">
                <slot :name="slot" v-bind="scope" />
            </div>
        </template>
        <template v-slot:modal-footer>
            <b-btn variant="secondary" @click="onCancel" v-if="!okOnly"> <i class="fa fa-times"></i> {{ cancelTitle }} </b-btn>
            <app-button :disabled="okDisabled" variant="primary" @click="$emit('ok')"> <i class="fa" :class="okIcon"></i> {{ okTitle }} </app-button>
        </template>
    </b-modal>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default: () => `modal-${parseInt(Math.random() * 1000000)}`,
        },
        title: {
            type: String,
            default: 'Vecindapp',
        },
        okTitle: {
            type: String,
            default: 'Aceptar',
        },
        cancelTitle: {
            type: String,
            default: 'Cancelar',
        },
        okIcon: {
            type: String,
            default: 'fa-check',
        },
        okDisabled: {
            type: Boolean,
            default: false,
        },
        okOnly: {
            type: Boolean,
            default: false,
        },
        tall: {
            type: Boolean,
            default: false,
        },
        cancel: {
            type: Function,
        },
    },
    methods: {
        onOk(event) {
            event.preventDefault()
        },
        onCancel(event) {
            if (!!this.cancel) return this.cancel(event)
            this.closeModal(this.id)
        },
    },
}
</script>
<style scoped>
.tall {
    min-height: 100vh;
}
</style>
